// reducers/notificationReducer.js
import { SHOW_MESSAGES, CLEAR_MESSAGES } from '../constants/ActionsTypes'

const initialState = []

function rootReducer(state = initialState, action) {
    switch (action.type) {
    case SHOW_MESSAGES:
      return Array.isArray(action.payload) ? action.payload : [action.payload]
    case CLEAR_MESSAGES:
      return []
    default:
      return state
  }
}

export default rootReducer
